import { type WritableDraft } from 'immer';
import { type Observable, of } from 'rxjs';

import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type EngineState } from '../../../+state/engine';
import {
  AbstractAiElementHandler,
  applyFieldSize,
  getElement,
  getInitialProps,
  patchFieldLabel,
  upsertElement,
} from '../../../ai';

import { type TagsContext } from './tags.definition';

export class TagsElementHandler extends AbstractAiElementHandler<'tags'> {
  readonly type = 'tags';

  prepare(context: TagsContext): Observable<TagsContext> {
    this.resolveElementIcon(context.element);
    return of(context);
  }

  process(context: TagsContext, draft: WritableDraft<EngineState>): void {
    let props: PartialPropsOf<'tags'> = getInitialProps<'tags'>(draft, context.element.id, {});
    props = patchFieldLabel<'tags'>(props, context.element);

    if (context.element.placeholder !== undefined) {
      props = applyPropsPatch<'tags'>(props, {
        content: { tags: { placeholder: context.element.placeholder } },
      });
    }

    if (context.element.isReadOnly !== undefined) {
      props = applyPropsPatch<'tags'>(props, {
        content: { options: { readonly: context.element.isReadOnly } },
      });
    }

    if (context.element.displayProperties?.sortBy !== undefined) {
      props = applyPropsPatch<'tags'>(props, {
        content: { sort: { field: context.element.displayProperties.sortBy, direction: 'asc' } },
      });
    }

    const { elementId } = upsertElement(draft, context, props);
    applyFieldSize<'tags'>(getElement(draft, elementId, 'tags'), context.element);
  }
}
